import React from 'react';

const PageFooter = ({ progress }) => {

  return (
    <div className='questionFooter'>
                        <div className='progressQuestions'><progress className='progress_Bar' value={progress} max='100'/></div>
                        <div className='footerEmpty'></div>
                    </div>
  );
};

export default PageFooter;
